import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';

export const FETCH_ARTICLE_EDIT_PERMISSION =
	'state.actions.fetch-article-edit-permission.FETCH_ARTICLE_EDIT_PERMISSION';

export type FetchArticleEditPermissionAction = {
	type: typeof FETCH_ARTICLE_EDIT_PERMISSION;
	payload: {
		id: string;
		accountId: AccountId | null;
		createAnalyticsEvent: CreateUIAnalyticsEvent;
		spaceKey: string;
	};
};

export const fetchArticleEditPermission = (
	id: string,
	accountId: AccountId | null,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	spaceKey: string,
): FetchArticleEditPermissionAction => ({
	type: FETCH_ARTICLE_EDIT_PERMISSION,
	payload: {
		id,
		spaceKey,
		accountId,
		createAnalyticsEvent,
	},
});
